<template>
    <div class="main-container">
        <a-layout>
            <a-layout :style="{ height: '100vh' }">
                <a-layout-header class="main-header">
                    <div class="header-container">
                        <a-button type="default" class="collapse-tool" @click="collapsed = !collapsed">
                            <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
                        </a-button>
                        <div class="sider-logo" theme="light"></div>
                        <div class="menu-container">
                            <a-menu class="user-name" theme="light" mode="horizontal" @click="handleSelect">
                                <a-menu-item key="dw">
                                    <a-icon type="home" />
                                    单位名称：{{ getUserInfo.companyInfo.dwmc }}
                                </a-menu-item>
                                <a-menu-item key="lb">
                                    <a-icon type="idcard" />
                                    类别：{{ getUserInfo.companyInfo.dwlb }}
                                </a-menu-item>
                                <a-sub-menu>
                                    <span slot="title"><a-icon type="user" />用户名：{{ getUserInfo.user_name }}</span>
                                    <a-menu-item key="/main/dwinfo">
                                        单位信息
                                    </a-menu-item>
                                    <a-menu-item key="/main/system/modifypassword">
                                        修改密码
                                    </a-menu-item>
                                </a-sub-menu>
                                <!-- <a-menu-item key="home">
                                    <a-icon type="form" style="color:skyblue" />
                                    反馈
                                </a-menu-item> -->
                                <a-menu-item key="/login">
                                    <a-icon type="logout" style="color:red" />
                                    退出登录
                                </a-menu-item>
                            </a-menu>
                        </div>
                    </div>
                </a-layout-header>
                <a-layout>
                    <a-layout-sider v-model="collapsed" collapsible theme="light" :trigger="null">
                        <a-menu theme="light" mode="inline" v-model="current" @click="handleSelect" :openKeys="openMenuKeys" @openChange="openChange">
                            <a-menu-item key="/main/home"> <span>首页</span> </a-menu-item>
                            <template v-for="item in menuDatas">
                                <a-menu-item v-if="!item.children" :key="item.id">
                                    <a-icon v-if="item.menu_icon" :type="item.menu_icon" />
                                    {{ item.menu_name }}
                                </a-menu-item>
                                <sub-menu v-else :key="item.id" :menu-info="item" />
                            </template>
                        </a-menu>
                    </a-layout-sider>
                    <a-layout-content class="main-content">
                        <div class="content-container">
                            <transition name="right" mode="out-in">
                                <router-view v-if="loaded" />
                            </transition>
                        </div>
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </a-layout>
        <ChangeInfo :showEdit.sync="editProps.showEdit" :needChangePwd.sync="editProps.needChangePwd" />
        <a-back-top :visibilityHeight="100" :target="getModuleContainer" />
    </div>
</template>
<script>
import ChangeInfo from "./userInfo/ChangeInfo";
import { mapActions, createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
import { Menu } from "ant-design-vue";
const SubMenu = {
    template: `
      <a-sub-menu :key="menuInfo.fun_entry" v-bind="$props" v-on="$listeners">
        <div slot="title" @click="handleSelect(menuInfo.fun_entry)">
           <a-icon v-if="menuInfo.menu_icon" :type="menuInfo.menu_icon" /><span>{{ menuInfo.menu_name }}</span>
        </div>
        <template v-for="item in menuInfo.children">
          <a-menu-item v-if="!item.children && item.fun_entry" :key="item.fun_entry" @click="handleSelect(item.fun_entry)">
              <a-icon v-if="item.menu_icon" :type="item.menu_icon" />
              {{ item.menu_name }}
          </a-menu-item>
          <a-menu-item-group v-else>
            <div slot="title">
              <a-icon v-if="item.menu_icon" :type="item.menu_icon" /><span>{{ item.menu_name }}</span>
            </div>
            <a-menu-item v-for="itemChildren in item.children" :key="itemChildren.fun_entry" @click="handleSelect(itemChildren.fun_entry)">
              <a-icon v-if="itemChildren.menu_icon" :type="itemChildren.menu_icon" />
              {{ itemChildren.menu_name }}
            </a-menu-item>
          </a-menu-item-group>
        </template>
      </a-sub-menu>
    `,
    name: "SubMenu",
    // must add isSubMenu: true
    isSubMenu: true,
    props: {
        ...Menu.SubMenu.props,
        // Cannot overlap with properties within Menu.SubMenu.props
        menuInfo: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        handleSelect(key) {
            if (isNaN(key)) {
                this.$listeners.click({ key: key });
            }
        }
    }
};
export default {
    components: { ChangeInfo, SubMenu },
    data() {
        return {
            loaded: false,
            current: [],
            // 展开的菜单
            openMenuKeys: [],
            //  编辑器属性
            editProps: {
                showEdit: false,
                needChangePwd: false
            },
            showEdit: false,
            menu: [],
            hometype: 1,
            menuDatas: [],
            collapsed: false,
            default_icon: "folder"
        };
    },
    created() {
        this.removeEmplyChildren(this.getUserMenus);
        this.menuDatas = this.getUserMenus;
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getUserMenus"])
    },
    watch: {
        $route: {
            handler(to) {
                // 设置当前菜单
                this.currentMenu = [to.fullPath];
                let parentArray = [];
                this.findMenuInfo(this.getUserMenus, to.fullPath, parentArray);
                if (!this.collapsed) {
                    this.openMenuKeys = parentArray.map((item) => item.id);
                } else {
                    this.openMenuKeys = [];
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        ...mapActions(["setStaticVarData", "setMessageData", "setDictData", "setSelectData", "setObjVarData"]),
        handleSelect({ key }) {
            if (key === "/login") {
                this.$FG_message.confirm("P0000", "退出登录").then((btn) => {
                    if (btn === "ok") {
                        this.$router.push({ name: "login" });
                    }
                });
            } else if (key === "/main/system/modifypassword") {
                this.editProps.showEdit = true;
                this.editProps.needChangePwd = false;
            } else if (key === "lb" || key === "dw") {
                return;
            } else {
                if (this.currentMenu && this.currentMenu[0] === key) {
                    return;
                }
                this.$router.push({ path: key });
            }
        },
        // 根据路由查找菜单信息
        findMenuInfo(menus, path, parentArray) {
            if (menus) {
                for (let i = 0; i < menus.length; i++) {
                    if (menus[i].fun_entry === path) {
                        return menus[i];
                    } else {
                        let info = this.findMenuInfo(menus[i].children, path, parentArray);
                        if (info) {
                            parentArray.push(menus[i]);
                            return info;
                        }
                    }
                }
            }
            return null;
        },
        openChange(openKeys) {
            // 过滤空的key，当左侧菜单收拢时可能会出现undefined的key
            let newKeys = openKeys.filter((item) => item);
            if (newKeys && newKeys.length > 0) {
                this.openMenuKeys = [newKeys[newKeys.length - 1]];
            } else {
                this.openMenuKeys = [];
            }
        },
        // 去除空children
        removeEmplyChildren(menus) {
            if (menus) {
                menus.forEach((item) => {
                    if (item.children && item.children.length > 0) {
                        this.removeEmplyChildren(item.children);
                    } else {
                        item.children = null;
                    }
                });
            }
        }
    },
    mounted() {
        // 加载初始化信息
        this.loaded = false;
        this.$FG_http.post("./api/common/framecore/init", { scope: 0 }, { showError: true, showSuccess: false }).then(({ success, data, errMsg }) => {
            if (success) {
                // 设置初始化信息
                this.setStaticVarData(data.data.staticVar);
                this.setMessageData(data.data.staticMsg);
                this.setDictData(data.data.dictItem);
                this.setSelectData(data.data.selectInfo);
                this.setObjVarData(data.data.objVar);
            }
            this.loaded = true;
        });
        if (this.getUserInfo.needChangePwd) {
            this.editProps.showEdit = true;
            this.editProps.needChangePwd = true;
        }
    },
    beforeRouteEnter(to, from, next) {
        next(function(vm) {
            vm.current = [to.fullPath];
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.current = [to.fullPath];
        next();
    }
};
</script>
<style lang="scss" scoped>
.main-container {
    width: 100%;
    height: 100%;
    background-color: $mainBackgroundColor;

    .main-header {
        background-color: #fff;
        height: 47px;
        padding: 0;
        z-index: 1;
        box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

        .header-container {
            width: 100%;
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: row;

            .sider-logo {
                height: 47px;
                width: 450px;
                margin-left: 10px;
                background-image: url(../../assets/images/logo.png);
                background-repeat: no-repeat;
                background-position: 0 center;
                background-size: 90% auto;
            }

            .collapse-tool {
                border: none;
                font-size: 20px;
                height: 47px;
                line-height: 47px;
            }

            .hometype-btn {
                color: #ccc;
                font-size: 32px;
                line-height: 40px;

                span {
                    margin: 0 0.5em;
                    cursor: pointer;
                }
                span:hover {
                    color: #14eaa5;
                }
                .homesel {
                    color: #14eaa5;
                }
            }
        }
    }

    .main-content {
        .content-container {
            height: 100%;
            width: 100%;
            overflow: auto;
        }
    }

    .menu-container {
        position: absolute;
        right: 0;

        .menu {
            float: left;
            margin-right: 50px;
        }

        .user-name {
            float: left;
        }
    }
}
</style>
